import { render } from "./PaymentSentReceivedChart.vue?vue&type=template&id=739b9f8c&ts=true"
import script from "./PaymentSentReceivedChart.vue?vue&type=script&lang=ts"
export * from "./PaymentSentReceivedChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__